export default __webpack_public_path__ + "static/media/office1.a5779459.jpg";